/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Button, Image, Select } from "antd";
import PopOverCrewChange from "../PopOverCrewChange";
import { getInitials } from "../../../../../../config/utils";
import { PopUp } from "../../../../../../atoms/PopUp";
import ChangeCrewLeader from "../Popup/ChangeCrewLeader";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  changeOrAddCrewFromSchedule,
  moveOrRemoveCrewFromSchedule,
} from "../../../../ducks/services";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch, useAppSelector } from "../../../../../../config/hooks";
import {
  getScheduleByDay,
  getScheduleByWeek,
  getSchedulingFormData,
  schedulingFilters,
} from "../../../../ducks/actions";
import { SelectArrow, TickIcon } from "../../../../../../atoms/CustomIcons";

function PopOverCrew(props: any) {
  const {
    column,
    editCrew,
    crewDrop,
    setEditCrew,
    crewArray,
    selectedDate,
    setLoading,
    loading,
    hideEditIcon,
    weekStartDate,
  } = props;
  const dispatch = useAppDispatch();
  const [isChangeCrewLeaderOpen, setIsChangeCrewLeaderOpen] = useState(false);
  const [crewMemberData, setCrewMemberData] = useState<string | null>(null);
  const [crewMemberList, setCrewMemberList] = useState<
    { label: string; value: string }[]
  >([]);
  const schedulingFiltersData = useAppSelector(
    (state) => state?.schedule?.schedulingFiltersData
  );

  useEffect(() => {
    if (schedulingFiltersData?.data?.crews) {
      const allMembers = schedulingFiltersData?.data?.crews.flatMap(
        (crew: any) => crew?.crewMembers || []
      );
      const uniqueMembers = Array.from(
        new Map(allMembers.map((item: any) => [item["id"], item])).values()
      );
      const crewMembers = uniqueMembers?.map((crew: any) => ({
        label: `${crew?.first_name ?? ""} ${crew?.last_name ?? ""}`,
        value: crew?.id,
        icon: crew?.image_url ? (
          <Image width={24} src={crew?.image_url} />
        ) : (
          <div className="text_with_avatar">
            <Avatar className="participant_avatar">
              {getInitials(crew?.first_name ?? "", crew?.last_name ?? "")}
            </Avatar>
          </div>
        ),
      }));

      setCrewMemberList(crewMembers);
    }
  }, [schedulingFiltersData?.data]);
  console.log("crewArray---", crewArray, crewMemberList);

  const removeCrewMember = (memberIdToMove: string) => {
    const payload = {
      crew_attendance_id: memberIdToMove,
    };

    moveOrRemoveCrewFromSchedule(payload)
      .then(() => {
        if (weekStartDate) {
          const payload = {
            date: dayjs(weekStartDate).format("YYYY-MM-DD"),
          };
          dispatch(
            getScheduleByWeek(dayjs(weekStartDate).format("YYYY-MM-DD"))
          );
          dispatch(getSchedulingFormData(payload));
        }
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Crew member removed");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
      });
  };

  const addCrewMember = (value: string) => {
    setCrewMemberData(value);
    if (!value) return;
    const payload = {
      user_id: value,
      schedule_id: column?.id ? column.id : column?.[0]?.schedule_id,
    };
    changeOrAddCrewFromSchedule(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        if (weekStartDate) {
          const payload = {
            date: dayjs(weekStartDate).format("YYYY-MM-DD"),
          };
          dispatch(
            getScheduleByWeek(dayjs(weekStartDate).format("YYYY-MM-DD"))
          );
          dispatch(getSchedulingFormData(payload));
        }
        if (column?.id) {
          dispatch(getScheduleByDay(formattedDate));
        }
        setCrewMemberData(null);
        dispatch(schedulingFilters());
        SuccessMessage("Crew member added");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
      });
  };

  const ChangeCrewLeaderPopup = {
    visibility: isChangeCrewLeaderOpen,
    content: (
      <ChangeCrewLeader
        selectedDate={selectedDate}
        columnData={column}
        crewData={schedulingFiltersData?.data?.crews || []}
        crewLeaderId={crewArray?.find((item: any) => item.is_crew_leader)?.id}
        onClose={() => setIsChangeCrewLeaderOpen(false)}
        heading="Change crew leader for the day"
        paragraph={
          <>
            You can assign a different crew leader, technician, or production
            manager to lead the crew for the day.
          </>
        }
        btnText="Save changes"
        loading={loading}
        setLoading={setLoading}
      />
    ),
    width: 480,
    onCancel: () => setIsChangeCrewLeaderOpen(false),
  };

  const isPastDate = selectedDate
    ? new Date(selectedDate) < new Date(new Date().setHours(0, 0, 0, 0))
    : false;

  return (
    <div className="crewPopoverContent">
      <div className="crewPopTop">
        <h4>Crew details</h4>
        {column?.crewAttendances?.length > 0 &&
          !isPastDate &&
          !hideEditIcon && (
            <Button
              className={editCrew ? "editCrewDone" : "editCrewBtn"}
              onClick={(e) => {
                e.stopPropagation();
                setEditCrew(!editCrew);
              }}
              type={editCrew ? "primary" : "text"}
            >
              {editCrew ? (
                "Done"
              ) : (
                <Image src="/images/schedule/edit.svg" preview={false} />
              )}
            </Button>
          )}
      </div>

      <div className="crewPopDetail">
        {crewArray?.map((member: any) => (
          <div key={member.id} className="crewPopItem">
            <div className="crewWithAvatar">
              <div className="imageWrapper">
                {member?.member_image ? (
                  <Image src={member?.member_image} preview={false} />
                ) : (
                  <div className="text_with_avatar">
                    <Avatar className="participant_avatar">
                      {getInitials(
                        member?.member_first_name
                          ? member?.member_first_name
                          : member?.first_name ?? "",
                        member?.member_last_name
                          ? member?.member_last_name
                          : member?.last_name ?? ""
                      )}
                    </Avatar>
                  </div>
                )}
                {member?.is_crew_leader && (
                  <div className="statusIndicator">
                    <Image
                      src="/images/schedule/leader-star.svg"
                      preview={false}
                    />
                  </div>
                )}
              </div>
              <div className="crewPopName">
                <div className="name">{`${
                  member?.member_first_name
                    ? member?.member_first_name
                    : member?.first_name ?? ""
                } ${
                  member?.member_last_name
                    ? member?.member_last_name
                    : member?.last_name ?? ""
                }`}</div>
                {member.role && <div className="role">{member.role}</div>}
              </div>
            </div>

            {editCrew ? (
              <div style={{ height: "32px" }}>
                {member.is_crew_leader || member?.type === "leader" ? (
                  <Button
                    className="btn-sm"
                    icon={
                      <Image
                        src="/images/schedule/leader-icon.svg"
                        preview={false}
                      />
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsChangeCrewLeaderOpen(true);
                    }}
                  />
                ) : (
                  !member.crewLeaderId && (
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        padding: "2px 0",
                      }}
                    >
                      <Button
                        className="btn-sm"
                        icon={
                          <Image
                            src="/images/schedule/remove-btn.svg"
                            preview={false}
                          />
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          removeCrewMember(member.id);
                        }}
                      />

                      <PopOverCrewChange
                        crewDrop={crewDrop}
                        memberId={member.id}
                        crewLeaderId={member.crewLeaderId}
                        selectedDate={selectedDate}
                        weekStartDate={weekStartDate}
                      />
                    </div>
                  )
                )}
              </div>
            ) : member.status ? (
              <div className="crewPopPunchedIn">
                {member.punch_in_time ? (
                  <div
                    className="punchedIn"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color:
                        member.status === "late_punch_in"
                          ? "#F06400"
                          : member?.status === "punch_out"
                          ? "#98A3A9"
                          : "#27AE60",
                    }}
                  >
                    {member.status === "late_punch_in" && (
                      <Image
                        src="/images/schedule/late-indicator.svg"
                        preview={false}
                      />
                    )}
                    {member?.status === "punch_out"
                      ? "Punched out"
                      : "Punched in"}
                    , {dayjs(member.punch_in_time).format("h:mm A")}
                  </div>
                ) : (
                  <div className="noShow">No show</div>
                )}
              </div>
            ) : (
              <div
                className="crewPopPunchedIn noShow"
                style={{ color: "#9ea9ae", fontSize: "12px" }}
              >
                {" "}
                Not punched in{" "}
              </div>
            )}
          </div>
        ))}

        {editCrew && (
          <div>
            <Select
              style={{ width: "100%" }}
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Add crew member"
              onChange={addCrewMember}
              value={crewMemberData}
              options={crewMemberList?.filter(
                (e) =>
                  !crewArray.some(
                    (member: { member_id: string }) =>
                      member?.member_id === e.value
                  )
              )}
            />
            {/* {crewMemberData && (
              <Button
                onClick={addCrewMember}
                icon={<TickIcon style={{ color: "#00A07D" }} />}
                className="only_icon"
              />
            )} */}
          </div>
        )}
      </div>

      <PopUp {...ChangeCrewLeaderPopup} />
    </div>
  );
}

export default PopOverCrew;
